<template>
  <div class="item-list">
    <event-item
      v-for="item in data"
      :key="item.ID"
      :publish="item.Publish"
      :access="item.Access"
      :date="item.Date"
      :time="item.Start_Time"
      :countryID="item.ISO2_Country"
      :city="item.City"
      :hostname="item.Host_name"
      :remoteType="item.Type"
      :titleEvent="item.Title_event"
      :titleSession="item.Title_session"
      :titleTalk="item.Title_talk"
      :invitee1="item.Invitee1"
      :invitee2="item.Invitee2"
      :invitee1AWAWCH="item.Invitee1_AW_AWCH"
      :invitee2AWAWCH="item.Invitee1_AW_AWCH"
      :presentationType="item.Activity_Invitee1"
      :infoLink="item.Information_link"
      :regiLink="item.Registration_link"
      :infoText="item.Info_text"
      :hasRecording="item.Recording"
      :recLink="item.Recording_link"
      :langLabel="item.Language_ISO2"
    ></event-item>
  </div>
</template>

<script>

import EventItem from "./EventItem.vue";

export default {
  components: {
    EventItem,
  },
  props: {
    data: {
      type: Array,
      default: () => {},
      required: true,
    },
  },
};
</script>

<style scoped>
.events-list {
  /* max-width: 50rem; */
  /* margin: auto; */
}

h3 {
  margin: 40px 0 0 !important;
}
ul {
  list-style-type: none !important;
  padding: 0 !important;
}
li {
  display: inline-block !important;
  margin: 0 10px !important;
}
a {
  color: #428bfa !important;
  text-decoration: none !important;
}
a:hover {
  text-decoration: underline !important;
}
</style>